<template>
  <v-layout row wrap class="px-5">
    <v-flex xs9 class="pl-0 my-2">
      <v-icon color="primary" class="bg-info mb-1">info</v-icon>
      <span class="pl-2 font-weight-medium subtitle-1 darkblue--text">
        INFORMATION
      </span>
    </v-flex>
    <v-flex xs3 class="text-right pb-0 mt-2">
      <v-btn
        text
        class="px-0"
        :disabled="item.status === 'cancelled'"
        v-if="
          (item.status === 'to modify' ||
            item.status === 'approved' ||
            item.status === 'rejected' ||
            item.status === null) &&
            showAdhoc === false &&
            hasPermission('create_spending', 'create')
        "
        @click="toEdit(item.status)"
        style="cursor: pointer"
      >
        <v-icon color="secondblue"> mdi-square-edit-outline </v-icon>
        <span class="ml-2">Edit</span>
      </v-btn>
      <v-btn
        text
        class="px-0"
        v-else-if="
          (item.status === 'approved' ||
            item.status === 'rejected' ||
            item.status === 'adhoc') &&
            showAdhoc &&
            hasPermission('create_spending', 'create')
        "
        @click="toEdit('adhoc')"
        style="cursor: pointer"
      >
        <v-icon color="secondblue"> mdi-square-edit-outline </v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12>
      <table width="100%">
        <tr>
          <td class="font-weight-bold darkblue--text">IO Number</td>
          <td>{{ item ? item.io_number || '-' : '-' }}</td>
          <td class="font-weight-bold darkblue--text">Entity</td>
          <td>
            {{
              item.brand
                ? item.brand.entity
                  ? item.brand.entity.name
                  : '-'
                : '-'
            }}
          </td>
          <td class="font-weight-bold darkblue--text">Brand</td>
          <td>{{ item.brand ? item.brand.name : '-' }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold darkblue--text">Code</td>
          <td>{{ item ? item.code : '-' }}</td>
          <td class="font-weight-bold darkblue--text">House</td>
          <td>{{ item.house ? item.house.name : '-' }}</td>
          <td class="font-weight-bold darkblue--text">Stage</td>
          <td>
            {{ item.product ? item.product.stage.name : '-' }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold darkblue--text">Budget Owner</td>
          <td>
            {{ item.budgetOwner ? item.budgetOwner.desc : '-' }}
          </td>
          <td class="font-weight-bold darkblue--text">PIC</td>
          <td>{{ item ? item.pic : '-' }}</td>
          <td class="font-weight-bold darkblue--text">Cost Element</td>
          <td>
            {{ item.taxonomy ? item.taxonomy.costElement.desc : '-' }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold darkblue--text">Material Group</td>
          <td>
            {{ item.taxonomy ? item.taxonomy.mat_group : '-' }}
          </td>
          <td class="font-weight-bold darkblue--text">Nature Activity</td>
          <td>
            <span v-if="item.taxonomy">
              {{
                item.taxonomy.costCenter
                  ? item.taxonomy.costCenter.costNature.nature_activity
                  : '-'
              }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="font-weight-bold darkblue--text">Category</td>
          <td colspan="3">
            <span v-if="item.taxonomy">
              {{
                item.taxonomy.costCenter
                  ? item.taxonomy.costCenter.costNature.category
                  : '-'
              }}
            </span>
            <span v-else>-</span>
          </td>
        </tr>
      </table>
    </v-flex>
    <v-flex xs12>
      <hr class="hr-line" />
    </v-flex>
  </v-layout>
</template>

<script>
import ACLMixin from '../../mixins/ACLMixin';

export default {
  mixins: [ACLMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    toEdit: {
      type: Function,
      required: true
    },
    showAdhoc: {
      type: Boolean,
      required: true
    },
    isActiveRevise: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isRevise() {
      if (
        this.isActiveRevise &&
        (this.item.status === 'approved' || this.item.status === 'to modify')
      )
        return true;
      return false;
    }
  }
};
</script>
